import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import SplashScreen from './screens/SplashScreen';
import OrderSuccess from './screens/OrderSuccess';
import OrderStatus from './screens/OrderStatus';
import OrdersList from './screens/OrdersList';

const LegacyMenuRedirect = () => {
    const { outletId } = useParams();
    return <Navigate to={`/${outletId}`} replace />;
};

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/:outletId/success" element={<OrderSuccess />} />
            <Route path="/:outletId/orders" element={<OrdersList />} />
            <Route path="/:outletId/order-status" element={<OrderStatus />} />
            <Route path="/:outletId" element={<SplashScreen />} />
            <Route path="/menu/:outletId" element={<LegacyMenuRedirect />} />
            <Route path="/" element={<SplashScreen />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default AppRoutes;
